

import Vue from 'vue'
import Component from "vue-class-component";
import {IOnOffHandlers} from "bonomo/dist";
import {namespace} from "vuex-class";
import {IHoliday} from "@/store/modules/settingsModule";
import CreateButton from "@/components/shared/CreateButton.vue";

const settingsModule = namespace("settingsModule");

@Component({
  components: {
    CreateButton,
  }
})
export default class Holidays extends Vue {

  @settingsModule.Getter('holidays')
  private holidays!: IHoliday[];

  protected loading: boolean = true;
  protected showDialog: boolean = false;
  protected selectedDate: string = '';
  private subscribes: IOnOffHandlers = {};

  protected get items() {
    return this.holidays.sort((a: IHoliday, b: IHoliday) => a.data == b.data ? 0 : (a.data < b.data ? -1: 1)).reverse();
  }

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.loadData,
      'backend.call.OK.holidaysLoaded': this.onLoadedOK,
      'backend.call.KO.holidaysLoaded': this.onLoadedKO,
    });
    this.loadData();
  }
  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  protected onCreate() {
    this.showDialog = true;
  }
  protected allowedDates(d: string) {
    return d >= this.today();
  }
  protected onHideDialog() {
    this.showDialog = false;
  }
  protected onSubmitDialog() {
    this.loading = true;
    this.$store.dispatch('settingsModule/createHoliday', {date: this.selectedDate});
  }
  protected onDelete(item: IHoliday) {
    this.loading = true;
    this.$store.dispatch('settingsModule/deleteHoliday', {date: item.data});
  }

  private loadData() {
    this.$store.dispatch('settingsModule/fetchHolidays');
  }
  private onLoadedOK() {
    this.selectedDate = '';
    this.loading = false;
  }
  private onLoadedKO() {
    this.loading = false;
  }
  private today(): string {
    return (new Date()).toISOString().substring(0, 10);
  }

}

